import { Col, Row } from 'antd'
import { useState } from 'react'
import { DesignSubmittalDisposition } from 'shared'
import { DefaultOptionType } from 'components/CIMSSelect/types'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import CIMSSelect from 'components/CIMSSelect'
import CIMSComment from 'components/CIMSComment'
import { useWorkflowRollbackComment } from '../../../../../../../../../../../../components/CIMSComment/hooks/useWorkflowRollbackComment'
const help = HelpMessage.DesignSubmittals.Log

export const DisciplineAction: React.FC = () => {
  const dispositionOptions: DefaultOptionType[] = useOptions({
    items: Object.values(DesignSubmittalDisposition).map((disposition) => ({
      disposition,
    })),
    value: 'disposition',
    label: 'disposition',
    sort: 'disposition',
  })
  const [disposition, setDisposition] = useState<string>()
  return (
    <>
      <Row>
        <Col xs={24}>
          <CIMSFormItem
            name="disposition"
            label="Disposition"
            help={help.Disposition}
            requiredMessage="Please select a disposition"
          >
            <CIMSSelect
              simple
              options={dispositionOptions}
              onSelect={(value) => setDisposition(value.toString())}
            />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <CIMSFormItem
            {...useWorkflowRollbackComment({
              optional: disposition === DesignSubmittalDisposition.NoComments,
            })}
          >
            <CIMSComment />
          </CIMSFormItem>
        </Col>
      </Row>
    </>
  )
}
